import { render, staticRenderFns } from "./partnership.vue?vue&type=template&id=1006548b&scoped=true"
import script from "./partnership.vue?vue&type=script&lang=js"
export * from "./partnership.vue?vue&type=script&lang=js"
import style0 from "./partnership.vue?vue&type=style&index=0&id=1006548b&prod&scoped=true&lang=css"
import style1 from "./partnership.vue?vue&type=style&index=1&id=1006548b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1006548b",
  null
  
)

export default component.exports